"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var StepIconTheme = function StepIconTheme(colors) {
  return {
    styleOverrides: {
      root: {
        display: 'block',
        color: colors.lynch,
        width: 8,
        height: 8,
        borderRadius: '50%',
        border: '4px solid',
        fill: 'none',
        backgroundColor: colors.lynch,
        zIndex: 1,
        boxSizing: 'content-box',
        '&.Mui-completed': {
          color: colors.bleuDigital100,
          backgroundColor: colors.bleuDigital100
        },
        '&.Mui-active': {
          fill: 'none',
          color: colors.bleuDigital100,
          backgroundColor: colors.white
        }
      },
      text: {
        display: 'none'
      }
    }
  };
};

var _default = StepIconTheme;
exports["default"] = _default;